<template>
  <div>
    <MbSearch @goReload="goReload" ref="info"></MbSearch>
    <section id="con">
      <MbWhrSearch />
      <div class="mcn mcon02">
        <div class="left_tbl">
          <div class="mtbl">
            <table>
              <colgroup>
                <col width="45%" />
                <col width="55%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">종목코드</th>
                  <th scope="col">종목명</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in searchPages.items" :key="index">
                  <td class="ta_c">
                    <a @click="goMbNWPage(item.kwSymbol, media)">{{ item.symbol }}</a>
                  </td>
                  <td>
                    <span>{{ item.kwName }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="right_tbl">
          <div class="mtbl">
            <table>
              <colgroup>
                <col width="85" />
                <col width="70" />
                <col width="95" />
                <col width="*" />
                <col width="95" />
                <col width="95" />
                <col width="95" />
                <col width="125" />
              </colgroup>
              <thead :class="{ postic: isEmpty }">
                <tr>
                  <th scope="col" rowspan="2">기준</th>
                  <th scope="col" rowspan="2">(잠정)실적</th>
                  <th scope="col" colspan="3">EPS(USD)</th>
                  <th scope="col" colspan="3">실적공시 발표이후</th>
                </tr>
                <tr>
                  <th scope="col">컨센서스</th>
                  <th scope="col">
                    <select id="supVal" v-model="searchPages.supVal" @change="goSupPage()">
                      <option
                        v-for="(option, index) in searchPages.supVals"
                        v-bind:value="option.value"
                        :key="index"
                      >
                        {{ option.text }}
                      </option>
                    </select>
                  </th>
                  <th scope="col">실적공시일</th>
                  <th scope="col">경과일</th>
                  <th scope="col">수익률(%)</th>
                  <th scope="col">컨센변화율(%)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in searchPages.items" :key="index">
                  <td class="ta_c">{{ item.fqDate }}/{{ item.fiscalFlag }}</td>
                  <td class="ta_r">{{ item.eps }}</td>
                  <td class="ta_r">{{ item.consensus }}</td>
                  <td class="ta_r">{{ item.surpValue }}</td>
                  <td class="ta_c">{{ item.filingDate }}</td>
                  <td class="ta_c">{{ item.passDay }}</td>
                  <template v-if="item.tvo !== null">
                    <td class="ta_r">{{ item.tvo.before1yRate }}</td>
                    <td class="ta_r lst">{{ item.tvo.consenRatio }}</td>
                  </template>
                  <template v-else>
                    <td class="ta_r">-</td>
                    <td class="ta_r lst">-</td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="more" v-if="'Y' === searchPages.nextPgFlag">
          <a @click="goPage(searchPages.pageNo + 1)">더보기</a>
        </div>
      </div>
      <MbBottomInfo />
    </section>
  </div>
</template>

<script>
import MbWhrSearch from '@/components/kiwoom/usRecord/mb/common/WhrSearch'
import MbSearch from '@/components/kiwoom/usRecord/mb/common/Search'
import MbBottomInfo from '@/components/kiwoom/usRecord/mb/common/BottomInfo'
import { mapGetters } from 'vuex'
import axios from 'axios'
import commonMixin from '@/mixin/commonMixin.js'

export default {
  mixins: [commonMixin],
  components: {
    MbWhrSearch,
    MbSearch,
    MbBottomInfo
  },
  data () {
    return {
      searchPages: {
        pageNo: 1,
        pageSize: 10,
        totalRows: 0,
        nextPgFlag: 'N',
        items: [],
        supVal: 'ALL',
        supVals: [
          { text: '전체', value: 'ALL' },
          { text: '어닝서프라이즈', value: 'supA' },
          { text: '예상수준상회', value: 'supB' },
          { text: '예상치부합', value: 'supC' },
          { text: '예상수준하회', value: 'supD' },
          { text: '어닝쇼크', value: 'supE' }
        ]
      },
      isFixed: false
    }
  },
  methods: {
    setSearchPagesDataInit () {
      this.searchPages.items.splice(0)
      this.searchPages.pageNo = 1
      this.searchPages.totalRows = 0
      this.searchPages.nextPgFlag = 'N'
      this.searchPages.items = []
      this.searchPages.supVal = 'ALL'
    },
    init () {
      const params = {
        pageNo: this.searchPages.pageNo,
        pageSize: this.searchPages.pageSize,
        chkIndex: this.getUsRecordSettings.chkIndex,
        symbol: this.getUsRecordSettings.symbol,
        supVal: this.searchPages.supVal
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/earning/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        this.searchPages.totalRows = res.data.resObj.totalRows
        this.searchPages.nextPgFlag = res.data.resObj.nextPgFlag
        let len = 0
        if (res.data.resObj.mlist !== undefined) {
          len = res.data.resObj.mlist.length
        }

        for (var i = 0; i < len; i++) {
          this.searchPages.items.push(res.data.resObj.mlist[i])
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    initMmry () {
      const params = {
        pageNo: this.searchPages.pageNo,
        pageSize: this.searchPages.pageSize,
        chkIndex: this.getUsRecordSettings.chkIndex,
        symbol: this.getUsRecordSettings.symbol,
        supVal: this.searchPages.supVal
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/earning/getUsStockMainDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        this.searchPages.totalRows = res.data.resObj.totalRows
        this.searchPages.nextPgFlag = res.data.resObj.nextPgFlag
        let len = 0
        this.searchPages.items = []
        if (res.data.resObj.mlist !== undefined) {
          len = res.data.resObj.mlist.length
        }
        for (var i = 0; i < len; i++) {
          this.searchPages.items.push(res.data.resObj.mlist[i])
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPages.pageNo = parseInt(pageNo)
      this.init()
    },
    goReload () {
      this.setSearchPagesDataInit()
      this.goPage('1')
    },
    goSupPage () {
      this.setSearchPagesDataInit()
      this.searchPages.supVal = $('#supVal').val()
      this.goPage('1')
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    }
  },
  created () {
    this.$store.dispatch('initUSdata')
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }
    this.initMmry()
  },
  mounted () {
    setTimeout(() => {
      // 수정부분 (오른쪽 테이블 헤더 고정)
      const mc01 = document.querySelector('.mcon02')
      const mc01Top = mc01.offsetTop - 34
      const rightTblH = document.querySelector('.right_tbl thead')
      const rightTbl = document.querySelector('.right_tbl')
      const leftTblWidth = document.querySelector('.left_tbl').offsetWidth

      document.addEventListener('scroll', () => {
        // 현재 스크롤 위치를 계산
        const scrollPosition =
          window.scrollY || document.documentElement.scrollTop

        // 스크롤 위치가 rTableTop에 도달했는지 확인
        if (scrollPosition >= mc01Top) {
          rightTblH.classList.add('fixed-header')
          rightTblH.style.left = leftTblWidth + 'px'
          this.isFixed = true
        } else {
          rightTblH.classList.remove('fixed-header')
          rightTblH.style.left = 'auto'
          this.isFixed = false
        }

        if (this.isFixed) {
          rightTblH.style.left = leftTblWidth - rightTbl.scrollLeft + 'px'
        }
      })

      rightTbl.addEventListener('scroll', () => {
        // rightTbl이 고정 상태인 경우에만 left 위치를 조정
        if (this.isFixed) {
          rightTblH.style.left = `${leftTblWidth - rightTbl.scrollLeft}px`
        }
      })
    }, 500)
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    isEmpty () {
      if (this.searchPages.items && this.searchPages.items.length <= 0) {
        return true
      }
      return false
    }
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        this.setSearchPagesDataInit()
        var chkIndexChg = this.getUsRecordSettings.chkIndexChg
        if (val !== 'SYMBOL' && chkIndexChg) {
          this.$store.dispatch('saveUsSymChgFlagSetting', 'N')
          this.setSymbolDataReset()
          this.goPage('1')
        }
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        if (val) {
          this.setSearchPagesDataInit()
          this.goPage('1')
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/mb/Brecord.vue